import React, { useContext, useRef, useEffect, useState, useMemo } from 'react';
import { UserContext } from '../UserContext';
import axios from 'axios';
import { Card } from '@material-ui/core';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import './Dashboard.css';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { tokens } from "../theme";
import { Typography } from 'antd';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Link } from 'react-router-dom';

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import {
  ToggleButton, ToggleButtonGroup, LinearProgress,
  IconButton, Stack
} from '@mui/material';
import Chart from 'chart.js/auto';
import {RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
} from "recharts";
import dayjs from "dayjs";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {  Button, TextField } from '@mui/material';
import { Label } from '@mui/icons-material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
ChartJS.register(ArcElement, Tooltip, Legend);

function getMonths(centerMonth = dayjs()) {
  return [
    centerMonth.subtract(2, "month"),
    centerMonth.subtract(1, "month"),
    centerMonth,
    centerMonth.add(1, "month"),
    centerMonth.add(2, "month")
  ];
}

function VerticalMonthSelector({ centerMonth, setCenterMonth }) {
  const months = getMonths(centerMonth);

  return (
    <Box className="vertical-month-selector">
      <IconButton
        onClick={() => setCenterMonth(centerMonth.subtract(1, "month"))}
        size="small"
        className="month-selector-button"
      >
        <KeyboardDoubleArrowUpIcon className="month-selector-icon" />
      </IconButton>
      {months.map((month) => (
        <Box
          key={month.format("YYYY-MM")}
          className={`month-item ${month.isSame(centerMonth, "month") ? "month-item-selected" : ""}`}
          onClick={() => setCenterMonth(month)}
        >
          {month.format("MMM")}
        </Box>
      ))}
      <IconButton
        onClick={() => setCenterMonth(centerMonth.add(1, "month"))}
        size="small"
        className="month-selector-button"
      >
        <KeyboardDoubleArrowDownIcon className="month-selector-icon" />
      </IconButton>
    </Box>
  );
}

function aggregateMonthlyData(enquiryDetails, months) {
  const safeEnquiries = Array.isArray(enquiryDetails) ? enquiryDetails : [];
  return {
    chartData: months.map((month) => {
      const monthKey = month.format("MMM YYYY");
      const monthEnqs = safeEnquiries.filter(
        (enq) =>
          enq.created_at && dayjs(enq.created_at).isSame(month, "month")
      );
      const productCount = monthEnqs.reduce(
        (sum, enq) => sum + (Array.isArray(enq.product) ? enq.product.length : 0),
        0
      );
      const serviceCount = monthEnqs.reduce(
        (sum, enq) => sum + (Array.isArray(enq.service) ? enq.service.length : 0),
        0
      );
      return {
        month: monthKey,
        Product: productCount,
        Service: serviceCount,
      };
    }),
    keys: ["Product", "Service"],
  };
}

function getColorMap(keys) {
  const palette = ["#1976d2", "#ff9800"];
  const colorMap = {};
  keys.forEach((key, idx) => {
    colorMap[key] = palette[idx % palette.length];
  });
  return colorMap;
}

function MultiLineTrendChart({ data, keys, colorMap }) {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <LineChart data={data}>
        <XAxis dataKey="month" axisLine={false} tickLine={false} tick={false} />
        <YAxis allowDecimals={false} axisLine={false} tickLine={false} tick={false} />
        <Tooltip />
        {keys.map((key) => (
          <Line
            key={key}
            type="monotone"
            dataKey={key}
            stroke={colorMap[key]}
            strokeWidth={2}
            dot={{ r: 3 }}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}

function CustomLegend({ keys, colorMap }) {
  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" className="custom-legend">
      {keys.map((key) => (
        <Box key={key} className="legend-item">
          <Box className="legend-color" style={{ backgroundColor: colorMap[key] }} />
          <Typography variant="body2">{key}</Typography>
        </Box>
      ))}
    </Stack>
  );
}

const Dashboard = () => {
  const { user_id, role } = useContext(UserContext);
  const [dashboard, setDashboard] = useState({});
    const [newDashboard, setNewDashboard] = useState({});
  console.log(dashboard, "dashboard");
  console.log(newDashboard, "newDashboard");
  const [selected, setSelected] = useState('product');
  const [centerMonth, setCenterMonth] = useState(dayjs());
  const [slider, setSlider] = useState({ left: 0, width: 0 });
    const [selectedValue, setSelectedValue] = useState('total_count');
  const [dashboardChartData, setDashboardChartData] = useState([
    { name: 'Selected', value: newDashboard.total_count },
    { name: 'Not Selected', value: 0 },
  ]);


const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  useEffect(() => {
    updateChartData();
  }, [selectedValue]);

  const updateChartData = () => {
    let selectedValueCount = newDashboard[selectedValue];
    let notSelectedValueCount = newDashboard.total_count - selectedValueCount;
    setDashboardChartData([
      { name: 'Selected', value: selectedValueCount },
      { name: 'Not Selected', value: notSelectedValueCount },
    ]);
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const groupRef = useRef();
  const btnRefs = {
    product: useRef(),
    service: useRef(),
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    const updateSlider = () => {
      const btn = btnRefs[selected]?.current;
      const group = groupRef.current;
      if (btn && group) {
        const btnRect = btn.getBoundingClientRect();
        const groupRect = group.getBoundingClientRect();
        setSlider({
          left: btnRect.left - groupRect.left,
          width: btnRect.width,
        });
      }
    };
    updateSlider();
    window.addEventListener("resize", updateSlider);
    return () => window.removeEventListener("resize", updateSlider);
  }, [selected]);

  const months = getMonths(centerMonth);
  const { chartData, keys } = aggregateMonthlyData(dashboard?.enquiry_details ?? [], months);
  const colorMap = getColorMap(keys);
  Chart.register(ChartDataLabels);

  const fetchData = async () => {
    try {
      const response = await axios.get(`api/dashboard/?user_id=${user_id}&role=${role}`);
      setDashboard(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


   const fetchDashBoardData = async (start = null, end = null) => {
    try {
      let url = `api/dashboard-value/?user_id=${user_id}&role=${role}`;
      
      if (start && end) {
        const formattedStartDate = start.format('YYYY-MM-DD');
        const formattedEndDate = end.format('YYYY-MM-DD');
        url += `&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
      }
      
      const response = await axios.get(url);
      setNewDashboard(response.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  const handleFilterClick = () => {
    fetchDashBoardData(startDate, endDate);
  };
  
  useEffect(() => {
    fetchDashBoardData();
  }, []); 


  const Attendancedata = {
    labels: ["Present", "Absent"],
    datasets: [
      {
        label: "Attendance",
        data: [
          Number(dashboard?.attendance?.present_users) || 0,
          Number(dashboard?.attendance?.absent_users) || 0
        ],
        backgroundColor: ["#fb7102", "#4caf50"],
        borderColor: ["#fb7102", "#428e3c"],
        borderWidth: 2,
      },
    ],
  };

  const barData = selected === 'product'
    ? dashboard.product_asked || []
    : dashboard.service_asked || [];

  const totalEnquiries = barData.reduce((sum, item) => sum + Number(item.enquiry_count), 0);
  const now = new Date();
  const upcomingMeetings = (dashboard.enquiry_details || [])
    .filter(enq => enq.meeting_date && new Date(enq.meeting_date) > now)
    .sort((a, b) => new Date(a.meeting_date) - new Date(b.meeting_date));
  console.log(upcomingMeetings, "upcomingMeetings");

  const attendancePieChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'start',
        labels: {
          usePointStyle: true,
          pointStyle: 'rect',
          padding: 30,
        },
      },
      datalabels: {
        color: '#fff',
        font: {
          family: 'Josefin Sans, sans-serif',
          weight: 'bold',
          size: 18,
        },
        formatter: (value, context) => {
          const data = context.chart.data.datasets[0].data;
          const total = data.reduce((acc, val) => acc + val, 0);
          const percentage = total ? ((value / total) * 100).toFixed(0) : 0;
          return percentage + '%';
        },
      },
    },
  };

  const isToday = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };

  const hasTodayEnquiry = dashboard?.enquiry_details?.some(
    (enq) => isToday(enq.created_at)
  );
  const completedCount = dashboard?.enquiry_details?.filter(e => e.status === "Completed").length || 0;
  const percentage = totalEnquiries ? Math.round((completedCount / totalEnquiries) * 100) : 0;
// This effect will update the chart data whenever the dashboard data or the selected radio button changes
useEffect(() => {
  // Get the count for the currently selected item (fallback to 0)
  const selectedCount = newDashboard[selectedValue] || 0;
  // Get the total count (fallback to 0)
  const totalCount = newDashboard.total_count || 0;
  // Calculate the "Not Selected" part of the pie
  const notSelectedCount = totalCount - selectedCount;

  // Update the chart data
  setDashboardChartData([
    { name: 'Selected', value: selectedCount },
    { name: 'Not Selected', value: notSelectedCount },
  ]);
}, [newDashboard, selectedValue]); // Dependencies: re-run this effect when these change
  return (
     <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box className="dashboard-container">
      
      
      {/* Add a container for the date pickers and filter button */}
     <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'flex-end', gap: 2, mb: 3, mt: 3, ml: 3 }}>
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
          renderInput={(params) => <TextField {...params} />}
          sx={{
            '& .MuiInputBase-root': { // Target the internal input field
              backgroundColor: '#f5f5f5',
              borderRadius: 2,
            },
            '& .MuiInputLabel-root': { // Target the label
              color: 'darkblue',
            },
            
          }}
        />
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
          renderInput={(params) => <TextField {...params} />}
          sx={{
            '& .MuiInputBase-root': { // Target the internal input field
              backgroundColor: '#f5f5f5',
              borderRadius: 2,
            },
            '& .MuiInputLabel-root': { // Target the label
              color: 'darkblue',
            },
          }}
        />
        <Button  variant="contained" onClick={handleFilterClick}               
          sx={{
                background: "#fb7102",
                color: "white",
              }}>
          Apply Filter
        </Button>
      </Box>
      {/* First Row */}
      <Box className="first-half">
        <Box className="task-box">
          <Box className="task-box-row">
            <Card className="task-card1" component={Link} to="/EnquiryImport">
              <Box className="task-card-header">
                <Box>
                  <Typography className="text-style1">Funnel</Typography>
                  <Typography className="text-style1">count</Typography>
                </Box>
                <FilterAltIcon  className="task-icon1" />
              </Box>
              <Typography className="number-style1">{newDashboard.total_count}</Typography>
              <Typography className="analysis-text">Increased from last month</Typography>
            </Card>
            <Card className="task-card2"  component={Link} to="/CompanyList">
              <Box className="task-card-header">
                <Box>
                  <Typography className="text-style2">Pipeline</Typography>
                  <Typography className="text-style2">Count</Typography>
                </Box>
                <LinearScaleIcon className="task-icon2" />
              </Box>
             <Typography className="number-style2">
    {newDashboard?.interested_count + newDashboard?.send_info_count}
  </Typography>
              <Typography className="analysis-text">Increased from last month</Typography>
            </Card>
          </Box>
          <Box className="task-box-row">
            <Card className="task-card3" component={Link} to="/CompanyList">
              <Box className="task-card-header">
                <Box>
                  <Typography className="text-style3">Warm</Typography>
                  <Typography className="text-style3">count</Typography>
                </Box>
                <FireplaceIcon  className="task-icon3" />
              </Box>
             <Typography className="number-style3">{newDashboard.demo_schedule_count}</Typography>
              <Typography className="analysis-text">Increased from last month</Typography>
            </Card>
            <Card className="task-card4"   component={Link} to="/CompanyList">
              <Box className="task-card-header">
                <Box>
                  <Typography className="text-style4">Sale</Typography>
                  <Typography className="text-style4">count</Typography>
                </Box>
                <MonetizationOnIcon  className="task-icon4" />
              </Box>
              <Typography className="number-style4">{newDashboard.won_count}</Typography>
              <Typography className="analysis-text">Increased from last month</Typography>
            </Card>
          </Box>
        </Box>

<Box className="attendance-box">
  <Card className="attendance-chartstyle" sx={{ height: 500 }}>
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%',
        // overflowY: 'auto', // Enable vertical scrolling
        // REMOVED: overflow:'hidden', <--- This was preventing the scroll
        minHeight: 0, 
        pr: 1, // Optional: Adds padding on the right so the scrollbar doesn't cover content
      }}
    >
      <Box sx={{ flexGrow: 1, position: 'relative', minHeight: 0, flexShrink: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={dashboardChartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={40}
              outerRadius={60}
              fill="#8884d8"
              label={false}
            >
              {dashboardChartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={index === 0 ? '#82ca9d' : '#C7C5B5'} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        
        {/* Custom centered label */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            pointerEvents: 'none'
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: '60px',
              fontWeight: 'bold',
              color: '#333'
            }}
          >
            {newDashboard[selectedValue] || 0}
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ p: 2, flexShrink: 0 , maxHeight: 120}}>
        <RadioGroup value={selectedValue} onChange={handleChange}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              // gap: 1,
            }}
          >
            <FormControlLabel value="total_count" control={<Radio />} label="Total_Count" />
            <FormControlLabel value="noanswer_count" control={<Radio />} label="No_Answer" />
            <FormControlLabel value="notinterest_count" control={<Radio />} label="Not_Interested" />
            <FormControlLabel value="interested_count" control={<Radio />} label="Interested" />
            <FormControlLabel value="send_info_count" control={<Radio />} label="Send_Info" />
            <FormControlLabel value="call_back_count" control={<Radio />} label="Call_Back" />
          </Box>
        </RadioGroup>
      </Box>
    </Box>
  </Card>
</Box>

        <Box className="product-level">
          <Card className="product-level-card">
            <Box className="product-level-header">
              <Typography className="text-style product-text">
                {selected === 'product' ? 'Products Level' : 'Services Level'}
              </Typography>
              <Box
                ref={groupRef}
                className="toggle-group"
              >
                <Box
                  className="toggle-slider"
                  style={{
                    left: slider.left,
                    width: slider.width,
                  }}
                />
                <ToggleButtonGroup
                  value={selected}
                  exclusive
                  onChange={(_, newValue) => { if (newValue) setSelected(newValue); }}
                  size="small"
                  aria-label="Product or Service"
                  className="toggle-button-group"
                >
                  <ToggleButton
                    value="product"
                    aria-label="Product"
                    ref={btnRefs.product}
                    className="toggle-button"
                  >
                    Product
                  </ToggleButton>
                  <ToggleButton
                    value="service"
                    aria-label="Service"
                    ref={btnRefs.service}
                    className="toggle-button"
                  >
                    Service
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Box>
            <Box className="product-level-content">
              {barData.map((item, idx) => {
                const name = selected === 'product' ? item.product_name : item.service_name;
                const percent = totalEnquiries
                  ? ((item.enquiry_count / totalEnquiries) * 100).toFixed(0)
                  : 0;
                return (
                  <Box
                    key={name}
                    className="product-level-item"
                  >
                    <Typography className="product-name">
                      {name}
                    </Typography>
                    <Box className="progress-container">
                      <LinearProgress
                        variant="determinate"
                        value={Number(percent)}
                        className="progress-bar"
                      />
                    </Box>
                    <Typography className="progress-percent">
                      {percent}%
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Card>
        </Box>
      </Box>

      {/* Second Row */}
      <Box className="second-half">
        <Box className="graph-box">
          <Card className="graph-card">
            <Box className="graph-header">
              <Box>
                <Typography className="text-style">Focusing on </Typography>
                <Typography>Productivity analytics</Typography>
              </Box>
              <Typography className="text-style graph-month">
                {centerMonth.format("MMM YYYY")}
              </Typography>
            </Box>
            <Box className="graph-content">
              <VerticalMonthSelector
                centerMonth={centerMonth}
                setCenterMonth={setCenterMonth}
              />
              <Box className="chart-container">
                <Box className="chart-wrapper">
                  <MultiLineTrendChart data={chartData} keys={keys} colorMap={colorMap} />
                </Box>
                <CustomLegend keys={keys} colorMap={colorMap} />
              </Box>
            </Box>
          </Card>
        </Box>
        <Box className="upcoming-meeting">
          <Card className="meeting-card">
            <Typography className="text-style meeting-title">
              Upcoming Meeting
            </Typography>
            <Box className="meeting-content">
              {upcomingMeetings.length === 0 ? (
                <Typography className="no-meetings">No upcoming meetings</Typography>
              ) : (
                upcomingMeetings.map((meeting) => {
                  const dateObj = new Date(meeting.meeting_date);
                  const day = dateObj.toLocaleDateString('en-US', { weekday: 'short' });
                  const date = dateObj.toLocaleDateString('en-US', { day: '2-digit', month: 'short' });
                  const time = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                  return (
                    <Box
                      key={meeting.enquiry_id}
                      className="meeting-item"
                    >
                      <Box>
                        <Typography className="daydate">
                          {day}, {date}
                        </Typography>
                        <Typography className="time">
                          {time}
                        </Typography>
                      </Box>
                      <Typography className="daydate">
                        {meeting.company_name}
                      </Typography>
                    </Box>
                  );
                })
              )}
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
    </LocalizationProvider>
  );
};

export default Dashboard;